import { Plot } from '../../core/plot';
import { Adaptor } from '../../core/adaptor';
import { TinyLineOptions } from './types';
import { adaptor, meta } from './adaptor';
import { DEFAULT_OPTIONS } from './constants';
import { getTinyData } from './utils';

export type { TinyLineOptions };

export class TinyLine extends Plot<TinyLineOptions> {
  /**
   * è·åé»è®¤éç½®é¡¹
   * ä¾å¤é¨ä½¿ç¨
   */
  static getDefaultOptions(): Partial<TinyLineOptions> {
    return DEFAULT_OPTIONS;
  }

  /** å¾è¡¨ç±»å */
  public type: string = 'tiny-line';

  /**
   * @override
   * @param data
   */
  public changeData(data: TinyLineOptions['data']) {
    this.updateOption({ data });
    const { chart, options } = this;
    meta({ chart, options });
    chart.changeData(getTinyData(data));
  }

  protected getDefaultOptions() {
    return TinyLine.getDefaultOptions();
  }

  /**
   * è·å è¿·ä½ æçº¿å¾ çééå¨
   */
  protected getSchemaAdaptor(): Adaptor<TinyLineOptions> {
    return adaptor;
  }
}
